<template>
  <div class="login-form">
    <form class="login-form" ref="forgetForm" @keyup.enter="forgetLogin()">
      <div class="glob-error">
        <div class="error-box-g" v-if="forgetLoginError.hasError">
          <div>
            <span class="warn-icon">
              <unex-icon svg="warn"></unex-icon>
            </span>
            <span>{{ forgetLoginError.errMessage }}</span>
          </div>
        </div>
      </div>
      <div class="input-line">
        <div class="form-label">{{ $t("frame.mobile") }}</div>
        <el-input
          :class="{
            'v-error': forgetLoginError.mobileError
          }"
          :placeholder="$t('frame.please_enter')"
          v-model="forgetForm.mobile"
          autocomplete="off"
          name="f-mobile"
          @blur="forgetValidate('mobile')"
          @change="clearError('forget')"
        ></el-input>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ forgetLoginError.mobileError }}</span>
          </div>
        </transition>
      </div>
      <div class="input-line">
        <div class="captcha-input-wrap">
          <div class="form-label">{{ $t("frame.pic_code") }}</div>
          <el-input
            :class="{
              'v-error': forgetLoginError.loginCodeError
            }"
            :placeholder="$t('frame.please_enter')"
            v-model="forgetForm.loginCode"
            autocomplete="off"
            name="l-loginCode"
          ></el-input>
          <div class="captchaUrl-wrap">
            <el-tooltip popper-class="login-tooltip" placement="top">
              <div
                slot="content"
                class="tooltip-content"
                style="color: #666666 ;"
              >
                {{ $t("frame.renew_info") }}
              </div>
              <img
                v-if="captchaUrlLoad"
                :src="captchaUrl"
                @error="getCaptcha"
                class="validate-code"
                @click="getCaptcha"
              />
              <img v-else :src="captchaUrl" @click="getCaptcha" />
            </el-tooltip>
          </div>
        </div>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ forgetLoginError.loginCodeError }}</span>
          </div>
        </transition>
      </div>
      <div class="input-line">
        <div class="captcha-input-wrap">
          <div class="form-label">
            {{ $t("frame.code_validate") }}
          </div>
          <el-input
            :placeholder="$t('frame.please_enter')"
            v-model="forgetForm.code"
            autocomplete="off"
            name="f-code"
            @blur="forgetValidate('code')"
            @change="clearError('forget')"
            :class="{
              'v-error': forgetLoginError.codeError
            }"
          ></el-input>
          <div class="captchaUrl-wrap warp-code" @click="getForgetCode()">
            <span>{{ Fcodetext }}</span>
          </div>
        </div>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ forgetLoginError.codeError }}</span>
          </div>
        </transition>
      </div>
      <div class="input-line">
        <div class="form-label">
          {{ $t("frame.Set_newpassword") }}
        </div>
        <el-input
          style="display:none"
          id="forgetPassword"
          type="text"
          auto-complete="new-password"
          @keyup.native="setType"
        >
        </el-input>
        <el-input
          class="fPassword"
          type="text"
          :placeholder="$t('frame.please_passwrod')"
          v-model="forgetForm.password"
          auto-complete="new-password"
          @blur="forgetValidate('password')"
          @change="clearError('forget')"
          @keyup.native="setType"
          :class="{
            'v-error': forgetLoginError.passwordError
          }"
        >
          <i
            v-if="passwordType == 'text'"
            slot="suffix"
            class="el-input__icon unex-icon-eye"
            @click="restType()"
            style="font-size:18px;"
          ></i>
          <i
            v-if="passwordType !== 'text'"
            slot="suffix"
            class="el-input__icon unex-icon-eye-o"
            @click="restType()"
            style="font-size:18px;"
          ></i>
        </el-input>
        <transition name="heightchange">
          <div class="error-box">
            <span>{{ forgetLoginError.passwordError }}</span>
          </div>
        </transition>
      </div>
      <el-button class="submit" @click="forgetLogin()" type="primary">
        {{ $t("frame.submit_one") }}
      </el-button>
    </form>
    <div class="forget-span">
      <span @click="setHref('account')"
        >{{ $t("frame.Existing_account")
        }}<span class="m-login">{{ $t("frame.Go_to_login") }} </span></span
      >
      <span class="f-des"
        >{{ $t("frame.unbound_mobile") }}
        <el-tooltip popper-class="login-unbind-tip" placement="bottom-end">
          <div slot="content">
            {{ $t("frame.Unbound_one") }}<br />{{ $t("frame.Unbound_two") }}
          </div>
          <i class="svg-help unex-icon-help"></i>
        </el-tooltip>
      </span>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
const CryptoJS = require('crypto-js')
export default {
  data() {
    return {
      Fcodetext: this.$t("frame.get_validate"),
      FcodeCount: 1,
      forgetLoginError: {
        hasError: false,
        errMessage: null,
        mobileError: null,
        codeError: null,
        passwordError: null
      },
      forgetForm: {
        code: null,
        mobile: null,
        password: null
      },
      passwordType: "password"
    };
  },
  computed: {
    ...mapState({
      captchaUrl: state => state.frame.login.captchaUrl,
      captchaUrlLoad: state => state.frame.login.captchaUrlLoad
    })
  },
  methods: {
    ...mapMutations({
      setLoginType: "frame/login/setLoginType"
    }),
    ...mapActions({
      getCaptcha: "frame/login/getCaptcha"
    }),
    setHref(type) {
      this.setLoginType(type);
      this.getCaptcha();
    },
    //忘记密码验证码倒计时
    setForgetTime() {
      if (this.FcodeCount == 1) {
        window.clearInterval(this.forgetInterVal); //停止计时器
        this.Fcodetext = this.$t("frame.get_validate");
      } else {
        this.FcodeCount--;
        this.Fcodetext = this.FcodeCount + "s" + this.$t("frame.Re_acquire");
      }
    },
    async getForgetCode() {
      if (
        this.FcodeCount === 1 &&
        this.forgetForm.mobile &&
        this.forgetForm.loginCode
      ) {
        this.FcodeCount = 60;
        this.forgetInterVal = window.setInterval(this.setForgetTime, 1000);
        this.forgetLoginError.mobileError = "";
        let res = await this.$store.dispatch("frame/getMobileCode", {
          mobile: this.forgetForm.mobile,
          imageCode: this.forgetForm.loginCode
        });
        if (!res.success) {
          let code = res.code.substring(4);
          if (code == 2112 || code == 2113) {
            this.forgetLoginError.mobileError = res.message;
          } else if (code == 2016 || failImageCode(code)) {
            this.$message({
              message: res.message,
              type: "error",
              center: true,
              duration: 2000
            });
          }
          window.clearInterval(this.forgetInterVal); //停止计时器
          this.FcodeCount = 1;
          this.Fcodetext = this.$t("frame.get_validate");
          this.getCaptcha();
        } else {
          this.forgetLoginError.hasError = true;
          this.forgetLoginError.errMessage = this.$t("frame.please_check");
          setTimeout(() => {
            this.forgetLoginError.hasError = false;
          }, 3000);
        }
      }
      function failImageCode(code) {
        return code === "0503";
      }
    },
    //忘记登录
    async forgetLogin() {
      const aesMinEncrypt = word => {
        const _word = CryptoJS.enc.Utf8.parse(word),
            _key = CryptoJS.enc.Utf8.parse("v-QM.Jrg#eSk(b0f"),
            _iv = CryptoJS.enc.Utf8.parse("e@wj9N)Nxud$SrhA");
        const encrypted = CryptoJS.AES.encrypt(_word, _key, {
          iv: _iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
      }

      if (!this.forgetLoginError.passwordError) {
        if (
          this.forgetForm.mobile &&
          this.forgetForm.code &&
          this.forgetForm.password
        ) {
          const params = this.forgetForm;
          // params.password = aesMinEncrypt(params.password)
          let res = await this.$store.dispatch(
            "frame/forgetPassword",
            params
          );
          if (!res.success) {
            let code = res.code.substring(4);
            if (code == 2110) {
              this.forgetLoginError.codeError = res.message;
            } else if (code == 2113) {
              this.forgetLoginError.mobileError = res.message;
            } else if (
              code == 2114 ||
              code == 2115 ||
              code == 2116 ||
              code == 2117 ||
              code == 2107
            ) {
              this.forgetLoginError.passwordError = res.message;
            }
          } else {
            this.$message({
              message: this.$t("frame.password_edit_success"),
              type: "success",
              center: true,
              duration: 2000
            });
            this.loginValue = "password";
            window.clearInterval(this.forgetInterVal); //停止计时器
            this.Fcodetext = this.$t("frame.get_validate");
            this.setLoginType("account");
          }
        } else {
          for (let item in this.forgetForm) {
            this.forgetValidate(item);
          }
        }
      }
    },
    //忘记密码验证
    forgetValidate(name) {
      if (name === "mobile" && !this.forgetForm.mobile) {
        this.forgetLoginError.mobileError = this.$t(
          "frame.please_phone_number"
        );
      } else if (name === "mobile" && this.forgetForm.mobile) {
        this.forgetLoginError.mobileError;
      }

      if (name === "code" && !this.forgetForm.code) {
        this.forgetLoginError.codeError = this.$t("frame.please_SMS_number");
      } else if (name === "code" && this.forgetForm.code) {
        this.forgetLoginError.codeError = "";
      }

      if (name === "password" && !this.forgetForm.password) {
        this.forgetLoginError.passwordError = this.$t(
          "frame.please_new_password"
        );
      } else if (name === "password" && this.forgetForm.password) {
        this.forgetLoginError.passwordError = "";
      }
    },
    //密码框类型设置
    setType(event) {
      if (event.target.value.length <= 0) {
        event.target.type = "text";
      } else {
        event.target.type = this.passwordType;
      }
    },
    restType() {
      this.passwordType = this.passwordType == "password" ? "text" : "password";
      document.querySelector(".fPassword input").type = this.passwordType;
    },
    clearError() {
      this.forgetLoginError.hasError = false;
    }
  }
};
</script>
